import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/NewsSection.css';

// Imágenes para usar en las news
import news001 from '../assets/news001.png';
import news002 from '../assets/news002.png';
import news003 from '../assets/news003.jpg';

const NewsSection = () => {
    const [recentNews, setRecentNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        fetchRecentNews();
    }, []);

    const fetchRecentNews = async () => {
        try {
            const response = await fetch('/api/news/recent');
            const data = await response.json();
            if (data.success) {
                setRecentNews(data.news);
            }
        } catch (error) {
            console.error('Error fetching recent news:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleNewsClick = (slug) => {
        navigate(`/noticia/${slug}`);
    };

    // Imagen cargada desde el encabezado: no se necesita require aquí

    return (
      <div className="news-section">
      <Helmet>
        <title>Esc. Prim. Arturo Guerrero González T.M.</title>
        <meta name="description" content="Página oficial de la Escuela Primaria Arturo Guerrero González Turno Matutino." />
        <meta name="keywords" content="escuela, primaria, Arturo Guerrero González, educación, niños" />
        <meta name="author" content="Rodrigo Montor Velis" />
        <meta property="og:title" content="Esc. Prim. Arturo Guerrero González T.M." />
        <meta property="og:description" content="Página oficial de la Escuela Primaria Arturo Guerrero González Turno Matutino." />
        <meta property="og:image" content="https://primarturogro.edu.mx/uploads/LogoArturo.png" />
        <meta property="og:url" content="https://primarturogro.edu.mx" />
        <meta property="og:type" content="website" />
      </Helmet>

      {/* Sección de noticias dinámicas - COMENTADA TEMPORALMENTE
      <div className="dynamic-news-section">
        <h2>Noticias Recientes 📰</h2>
        {loading ? (
        <div className="loading">Cargando noticias...</div>
        ) : recentNews.length > 0 ? (
        <div className="recent-news-grid">
          {recentNews.map((news) => (
          <div 
            key={news.id} 
            className="recent-news-card"
            onClick={() => handleNewsClick(news.slug)}
          >
            {news.cover_image && (
            <div className="recent-news-image">
              <img src={news.cover_image} alt={news.title} />
            </div>
            )}
            <div className="recent-news-content">
            <h3>{news.title}</h3>
            <p>{news.summary}</p>
            <div className="recent-news-meta">
              <span className="author">Por: {news.author_name}</span>
              <span className="date">
              {new Date(news.created_at).toLocaleDateString('es-ES')}
              </span>
            </div>
            <button className="read-more-btn">
              Leer más →
            </button>
            </div>
          </div>
          ))}
        </div>
        ) : (
        <div className="no-news">
          <p>No hay noticias recientes disponibles.</p>
        </div>
        )}
      </div>
      */}

      <div className="news-cards-container">
        <div className="news-card">
        <h3>📝 Encuestas</h3>
        <p>Familias, estudiantes y docentes; apóyanos dando respuesta a las encuestas para la lectura de la realidad de nuestra comunidad en este Ciclo Escolar 2026-2027, ¡gracias por tu apoyo!.</p>
        <Link to="/encuestas">
          <button>Ver más</button>
        </Link>
        </div>
        <div className="news-card">
        <h3>📅 Calendario Oficial</h3>
        <p>Consulta las fechas del Calendario Oficial Federal para el Ciclo Escolar 2026-2027.</p>
        <button onClick={() => window.location.href='https://calendarioescolar.sep.gob.mx/2026-2027'}>
          Ver más
        </button>
        </div>
        <div className="news-card">
        <h3>📞 Contáctanos</h3>
        <p>Ante cualquier duda o información por favor contáctanos con nosotros, podrás obtener más información de nuestra ubicación e información.</p>
        <Link to="/contact">
          <button>Ver más</button>
        </Link>
        </div>
      </div>
      <div className="facebook-feed">
        <h3>📱 Publicaciones de Facebook</h3>
        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
          <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fprimarturogro&tabs=timeline&width=500&height=900&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
            width="500"
            height="900"
            style={{ border: 'none', overflow: 'hidden' }}
            scrolling="no"
            frameBorder="0"
            allowFullScreen={true}
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          ></iframe>
        </div>
      </div>
      </div>
    );
};

export default NewsSection;